// export function calcTotal({ price = 0, totalEditList = [], excludeDecrease = false, memberLevelPercent = 0, memberInfo = {}, fromText = '' }) {
//   // console.log('----------------------------------------')
//   if (fromText === '左下角應付總額') {
//     // console.log('這邊寫你要印出的東西')
//   }
//   const priceTotal = Array.isArray(price) && price.length ? price[price.length - 1] : price
//   return totalEditList.reduce((acc, cur, index) => {
//     let basePrice = cur.id ? cur.price * cur.qty : cur.price * cur.qty ?? cur.total
//     let memberLevelCurrentPercent = !cur.id ? memberLevelPercent : cur.levelDiscount
//     /**
//      * @description 如果是還沒加購過的，要去看memberLevel是什麼
//      */
//     if (cur.type === 'cosmetic-add' && !('levelDiscountValue' in cur)) {
//       if (Object.keys(memberInfo).length > 0) {
//         const { servicePrices } = memberInfo.level
//         const serviceIndex = servicePrices.findIndex(item => item.id === parseInt(cur.priceId))
//         memberLevelCurrentPercent = serviceIndex > -1 ? servicePrices[serviceIndex] : 0
//       }
//       if (typeof memberLevelCurrentPercent === 'object') {
//         // 如果是%，直接走這邊減掉
//         if (memberLevelCurrentPercent.discountType === '%') {
//           acc = acc + parseInt(basePrice - Math.round(basePrice * (parseInt(memberLevelCurrentPercent.discount) / 100)))
//         }
//         // 如果是fixed，走這邊，先判斷是否小於0，如果小於0則-0
//         if (memberLevelCurrentPercent.discountType === 'fixed') {
//           const addNumber = parseInt(basePrice - Math.round((parseInt(memberLevelCurrentPercent.discount) * cur.qty)))
//           acc = acc + (addNumber < 0 ? 0 : addNumber)
//         }
//         return acc
//       } else if (typeof memberLevelCurrentPercent === 'number') {
//         const result = acc + parseInt(basePrice - Math.round(basePrice * (memberLevelCurrentPercent / 100)))
//         return result < 0 ? 0 : result
//       }
//     }
//     /**
//      * @description 如果是已經加購過的，因為已經有資料，就不用在去看memberLevel是什麼
//      */
//     if (cur.type === 'cosmetic-add' && ('levelDiscountValue' in cur)) {
//       return acc + cur.qty * (cur.price - (cur.levelDiscountValue / cur.qty))
//     }

//     if(cur.type === 'goods') {
//       return acc + cur.price * cur.qty
//     }

//     // 加價
//     if (cur.type === '+' || cur.type === 'express') {
//       return acc + parseInt(basePrice)
//     }
//     // 減價
//     if (cur.type === '-' && !excludeDecrease) {
//       return acc - Math.abs(parseInt(basePrice))
//     }
//     // 折扣
//     if (cur.type === '%' && !excludeDecrease) {
//       const percent = (cur.description ?? cur.price) / 100
//       const discount = Math.round(acc * percent)
//       totalEditList[index].discount = discount // TotalTable 用來顯示折扣金額
//       return acc - discount
//     }
//     // 假服務
//     if (cur.type === 'cosmetic' && cur.priceId === 'fake') {
//       return cur.total
//     }
//     return acc * cur.qty
//   }, priceTotal)
// }

export function calcTotal({ price = 0, totalEditList = [], excludeDecrease = false, memberLevelPercent = 0, memberInfo = {}, fromText = '' }) {
  if (fromText === '左下角應付總額') {
    // 這邊寫你要印出的東西
  }
  const calculatePrice = (price, totalEditList) => {
    return totalEditList.reduce((acc, cur, index) => {
      let basePrice = cur.id ? cur.price * cur.qty : cur.price * cur.qty ?? cur.total
      let memberLevelCurrentPercent = !cur.id ? memberLevelPercent : cur.levelDiscount

      if (cur.type === 'cosmetic-add') {
        if (!('levelDiscountValue' in cur)) {
          if (Object.keys(memberInfo).length > 0) {
            const { servicePrices } = memberInfo.level
            const serviceIndex = servicePrices.findIndex((item) => item.id === parseInt(cur.priceId))
            memberLevelCurrentPercent = serviceIndex > -1 ? servicePrices[serviceIndex] : 0
          }
          if (typeof memberLevelCurrentPercent === 'object') {
            if (memberLevelCurrentPercent.discountType === '%') {
              acc += Math.max(0, basePrice - Math.round(basePrice * (parseInt(memberLevelCurrentPercent.discount) / 100)))
            } else if (memberLevelCurrentPercent.discountType === 'fixed') {
              const addNumber = Math.max(0, basePrice - Math.round(parseInt(memberLevelCurrentPercent.discount) * cur.qty))
              acc += addNumber
            }
          } else if (typeof memberLevelCurrentPercent === 'number') {
            const result = Math.max(0, basePrice - Math.round(basePrice * (memberLevelCurrentPercent / 100)))
            acc += result
          }
        } else {
          acc += cur.qty * (cur.price - cur.levelDiscountValue / cur.qty)
        }
        return acc
      }

      switch (cur.type) {
        case 'goods':
          return acc + cur.price * cur.qty
        case '+':
        case 'express':
          return acc + basePrice
        case '-':
          return excludeDecrease ? acc : acc - Math.abs(basePrice)
        case '%':
          if (!excludeDecrease) {
            const percent = (cur.description ?? cur.price) / 100
            const discount = Math.round(acc * percent)
            totalEditList[index].discount = discount // TotalTable 用來顯示折扣金額
            return acc - discount
          }
          return acc
        case 'cosmetic':
          if (cur.priceId === 'fake') {
            return cur.total
          }
          break
        default:
          return acc * cur.qty
      }
      return acc
    }, price)
  }
  return calculatePrice(price, totalEditList)
}

export function calcBasePrice({ price = 0, totalEditList = [], memberLevelPercent = 0 }) {
  return calcTotal({
    price,
    totalEditList,
    excludeDecrease: true,
    memberLevelPercent,
  })
}
